<template>
  <div class="page_part5">
    <div class="student_report_shengya">
      <div class="rzqn xqqx">
        <div class="rzqnTitle">兴趣倾向指标评估详细结果</div>
        <table v-if="arr.length>0">
          <tbody>
          <tr>
            <th>兴趣类型</th>
            <th width="40">2</th>
            <th width="40">4</th>
            <th width="40">6</th>
            <th width="40">8</th>
            <th width="40">10</th>
            <th width="40">12</th>
            <th width="40">14</th>
            <th width="40">16</th>
            <th width="40">18</th>
            <th width="40">20</th>
            <th>分数</th>
          </tr>
          <tr>
            <td class='blue'>
              实际型 <br/> （R）
            </td>
            <td colSpan='10'>
              <div  :style="{width:arr[0]&&arr[0]/20*400+'px'}">
              </div>
            </td>
            <td>{{arr[0]}}</td>
          </tr>
          <tr>
            <td class='blue'>
              研究型 <br/> （I）
            </td>
            <td colSpan='10'>
              <div  :style="{width:arr[1]&&arr[1]/20*400+'px'}">
              </div>
            </td>
            <td>{{arr[1]}}</td>
          </tr>
          <tr>
            <td class='blue'>
              艺术型 <br/> （A）
            </td>
            <td colSpan='10'>
              <div  :style="{width:arr[2]&&arr[2]/20*400+'px'}">
              </div>
            </td>
            <td>{{arr[2]}}</td>
          </tr>
          <tr>
            <td class='blue'>
              社会型  <br/> （S）
            </td>
            <td colSpan='10'>
              <div  :style="{width:arr[3]&&arr[3]/20*400+'px'}">
              </div>
            </td>
            <td>{{arr[3]}}</td>
          </tr>
          <tr>
            <td class='blue'>
              企业型 <br/> （E）
            </td>
            <td colSpan='10'>
              <div  :style="{width:arr[4]&&arr[4]/20*400+'px'}">
              </div>
            </td>
            <td>{{arr[4]}}</td>
          </tr>
          <tr>
            <td class='blue'>
              传统型 <br/> （C）
            </td>
            <td colSpan='10'>
              <div  :style="{width:arr[5]&&arr[5]/20*400+'px'}">
              </div>
            </td>
            <td>{{arr[5]}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
      <div class="bagua">
        <div id="Gossip"></div>
        <div class="result">
          <div class="result_left">
            <p>你的兴趣代码是：<span>{{hobby.threeYard}}</span></p>
          </div>
          <div class="result_right">
            <p>你的兴趣倾向是：<span v-if="hobby.interestTendency">{{hobby.interestTendency[0]}}、{{hobby.interestTendency[1]}}</span></p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import echarts2 from "echarts";

export default {
  props:{
    hobby:{
      type:Object
    },
    
    // threeCategory:{
    //   type:Array
    // },
    // profession:{
    //   type:Object
    // }
  },
  data() {
    return {
      options:{},
      radarChart:[],
      bgArr: [], //八卦
      bgNewArr:["R-实际型","C-传统型","E-企业型","S-社会型","A-艺术型","I-研究型"],
      bgNewArr2:[],
      radarValue:[],
      threeYard:'',
      norm:{},
      updata:true,
      arr:[],
      bool:true
    };
  },
  created() {
  },
  mounted() {
  },
  updated(){
    this.draw()
  },
  watch:{
    hobby(newval,oldval){
      // console.log(newval.radarChart)
      let arr=[]
      let radarChart = newval.radarChart
      radarChart.forEach(item=>{
        item.type=='R'&&(arr[0]=item.value);
        item.type=='I'&&(arr[1]=item.value);
        item.type=='A'&&(arr[2]=item.value);
        item.type=='S'&&(arr[3]=item.value);
        item.type=='E'&&(arr[4]=item.value);
        item.type=='C'&&(arr[5]=item.value);
      })
      this.arr=arr
    }
  },
  methods: {
    draw(){
      // RIASEC
      if(!this.bool){
        return
      }
      this.bool=false
      this.radarChart = this.hobby.radarChart; //雷达图
      this.threeYard = this.hobby.threeYard
      for (var i = 0; i < this.radarChart.length; i++) {
            this.bgArr.push({
              name: this.radarChart[i].type + "-" + this.radarChart[i].name,
              value: this.radarChart[i].value,
              max: 20,
              type: this.radarChart[i].type
            });
          }
         
          for (var i = 0; i < this.threeYard.length; i++) {
            for (var j = 0; j < this.bgArr.length; j++) {
                if (this.threeYard[i] == this.bgArr[j].type) {
                    this.bgArr[j].color = "#1CA4B6"
                    // this.bgArr[j].fontSize = "20"
                }
            }
        }

          for(var i = 0;i<this.bgNewArr.length;i++){
            this.bgArr.forEach((item) => {
             
              if(this.bgNewArr[i] == item.name){
                this.bgNewArr2.push(item)
              }
            })
          }
          for(var i = 0;i<this.bgNewArr2.length;i++){
              this.radarValue.push(this.bgNewArr2[i].value)
          }
     // this.radarValue = this.hobby.radarValue; //雷达图
     this.$nextTick(()=>{
        this.drawBagua(this.bgNewArr2)
     })
      // let  echarts = require("echarts");
      // let myChart2 = echarts2.init(document.getElementById("Gossip"));
      // myChart2.setOption(this.options);
    },
    drawBagua(value) {
      
      var echarts2 = require("echarts");
      var myChart2 = echarts2.init(document.getElementById("Gossip"));
      var iarr = []
      myChart2.setOption(
        {
        tooltip: {
          trigger: "item",
        },
        radar: {
          // shape: 'circle',
          name: {
            formatter: function (val) {
                          
                            let values = false
                            for (let i = 0; i < value.length; i++) {
                                if (value[i].name == val && value[i].color) {
                                    values=true
                                   break
                                }
                            }
                            if(values){
                                return '{a|' + val + '}'
                            }else{
                                return '{b|' + val + '}'
                            }
                           
                        },
           
            rich: {
              a: {
                 color: "#1CA4B6",
                fontSize: 18,
              },
              b: {
                color: "#2F2F2F",
                fontSize: 14,
               
              },
            },
            textStyle: {
              color: "#4D4D4D",
              fontSize: 14,
              fontWeight: "bold",
              padding: [3, 5],
            },
          },

          axisLine: {
            //指向外圈文本的分隔线样式
            lineStyle: {
              type: "dashed",
            },
          },
          splitArea: {
            show: true,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
          radius: "70%",
          center: ["50%", "50%"],
          // indicator: this.bgArr,
          indicator:value
        },
        series: [
          {
            name: "测评结果",
            type: "radar",
            // areaStyle: {normal: {}},
            data: [
              {
                value: this.radarValue,
                name: "测评结果",
                label: {
                  show: true,
                  formatter: function (params) {
                    iarr.push(params)
                    // if (params.value <= 10) {
                    //   return "{a|" + params.value + "}";
                    // } else {
                    //   return "{b|" + params.value + "}";
                    // }
                    for (var i = 0; i < value.length; i++) {
                                if (value[i].value == params.value && value[iarr.length - 1].color) {
                                    return '{b|' + params.value + '}';
                                }



                            }
                  },
                  rich: {
                    a: {
                      color: "#2F2F2F",
                      fontSize: 14,
                    },
                    b: {
                      color: "#1CA4B6",
                      fontSize: 18,
                    },
                  },
                },
              },
            ],
            areaStyle: {
              color: "rgba(184,232,255,0.8)",
            },
            lineStyle: {
              color: "#1CA4B6",
              width: 2,
            },
            label: {
              show: true,
              position: "top",
              fontSize: 14,
              color: "#2F2F2F",

              // fontWeight:'bold'
            },
            symbol: "circle",
            symbolSize: 4,
            showAllSymbol: false,

            itemStyle: {
              color: "white",
              borderColor: "#1CA4B6",
              borderWidth: 2,
            },
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
@import './report.css';
#lineTu {
  width: 100%;
  height: 400px;
}
#Gossip {
  width: 100%;
  height: 600px;
}

.jie_list {
  width: 100%;
  /* height: 252px; */
  border: 1px dashed #e6e6e6;
  border-radius: 6px 6px 0px 0px;
  background: #f6f6f6;
  padding: 0 15px 15px;
  box-sizing: border-box;
  margin-top: 30px;
}
.jie_list p.jie_title {
  font-size: 14px;
  font-weight: 400;
  color: #2f2f2f;
  height: 44px;
  line-height: 44px;
  border-bottom: 1px dashed #e6e6e6;
}
.jie_list .jie_title span {
  font-size: 16px;
  color: #1ca4b6;
  font-weight: 600;
}
.jie_mian p {
  font-size: 15px;
  font-weight: 600;
  color: #333333;
  margin-top: 15px;
}
.jie_mian ul li {
  font-size: 14px;
  font-weight: 400;
  line-height: 2;
  color: #9e9e9e;
}

.result {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}
.result_left,
.result_right {
  width: 315px;
  height: 40px;
  background: #f6f6f6;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.result_left p span {
  font-size: 20px;
  color: #1ca4b6;
  vertical-align: middle;
}
.result_right p span {
  font-size: 20px;
  color: #f6a724;
  vertical-align: middle;
}


h5.page_bg_o {
  background-color: #feae3b;
}

h5.header {
  color: #fff;
  font-size: 24px;
  text-align: left;
  margin: 30px 0 15px 0;
  line-height: 50px;
  padding-left: 15px;
}
.page_title_2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 32px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin: 20px 0 10px 0;
}
.page_part2 .page_title_2 .arrow {
}
h5.page_bg_bl {
  background-color: #1ca4b6;
}
.page_title_2 span {
  line-height: 32px;
  font-size: 20px;
  font-weight: 700;
}
.page_title_2 .arrow {
  display: block;
  margin-left: 10px;
  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  /* border-left: 14px solid #feae3b; */
  border-left: 14px solid #19b1c4;
  border-bottom: 9px solid transparent;
}
.header_detail_box .header_detail {
  text-indent: 2em;
  line-height: 32px;
  font-size: 15px;
  color: #4f4e4e;
}

.line_box2 {
  margin: 40px 0 20px 0;
}

.jie_bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.jie_left {
  width: 334px;
  height: 163px;
  background: url("/public/imgs/cepingreport/page_3_33.png")
  no-repeat;
  background-size: cover;
  padding: 15px;
  box-sizing: border-box;
}
.jie_right {
  width: 334px;
  height: 163px;
  background: url("/public/imgs/cepingreport/page_3_34.png")
  no-repeat;
  background-size: cover;
  padding: 15px;
  box-sizing: border-box;
}
.jie_left p:first-child {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  line-height: 2;
}
.jie_left p:first-child span {
  font-size: 16px;
  color: #ffc002;
  font-weight: 600;
  margin-left: 10px;
}
.jie_left p:last-child {
  margin-top: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 1.5;
}
.jie_right p:first-child {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  line-height: 2;

}
.jie_right p:first-child span {
  font-size: 16px;
  color: #28dfa0;
  font-weight: 600;
  margin-left: 10px;
}
.jie_right p:last-child {
  margin-top: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 1.5;
}
.bgfont{
  background: #f6a724;
}
.bgfont2{
  background: #1CA4B6;
}
.bgfont3{
  background: #1CA4B6;
}

.linebox .line_info{
  font-size: 14px;
  font-weight: 400;
  color: #B0B0B0;
  margin: 15px 0;
}
.echarts_com{
  display: flex;
  justify-content: space-between;
}

.com_left,.com_right{
  width: 311px;
  height: 40px;
  background: #F6F6F6;
  border-radius: 6px;
  line-height: 40px;
  text-align: center;
}
.com_left p,.com_right p{
  font-size: 14px;
  color: #2F2F2F;
}

.com_left p span{
  color: #1CA4B6;
  font-size: 16px;
  font-weight: 600;
}
.com_right p span{
  color: #FEAE3B;
  font-size: 16px;
  font-weight: 600;
}
.page_js{
  margin-bottom: 60px;
  height: auto;
  background: #f5f5f5;
  border-radius: 6px;
  padding: 30px 15px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
}
.page_js .page_bg_o{
  background: #FEAE3B;
}
.page_js .page_bg_bl{
  background: #00B3F0;
}
.page_js .page_bg_g{
  background: #AACF00;
}
.page_zyjs{
  width: auto;
  padding: 0 15px;
  height: 30px;
  /* background: #3AB3C1; */
  border-radius: 6px;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: absolute;
  top: -15px;
}
.page_js ul li{
  text-indent: 2em;
  line-height: 2;
  font-size: 14px;
  color: #969696;
}
</style>
<style lang="less" scoped>
  @import '../../css/evaluationReport.less';
</style>